(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pb-bundle-page"]) return;
  try {
    
const pbBundleSeriesIds = ['pb-pro-packages','pb-lumo-packages','pb-hawk-packages','pb-petitage-packages'];
const pbOpenBundleSeries = id => {if(!pbBundleSeriesIds.includes(id))return;const details=document.getElementById(id);if(details)details.open=true;};
const pbOpenBundleHash = () => pbOpenBundleSeries(window.location.hash.slice(1));
document.addEventListener('click',event=>{const link=event.target.closest('[data-pb-open-series]');if(link)pbOpenBundleSeries(link.dataset.pbOpenSeries);});
window.addEventListener('hashchange',pbOpenBundleHash);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',pbOpenBundleHash,{once:true});else pbOpenBundleHash();

  } catch(e) { console.error(e); }
})();
})();
